import React, { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash";

import { saveProduct as saveProductAction } from "../../Store/Modules/Menu/Actions";

export const Context = React.createContext();

export default function reducer(state, action) {
  switch (action.type) {
    case "INIT":
      return action.product;
    case "REPLACE":
      return {
        ...action.product,
      };
    case "REPLACE_ANSWERS":
      return {
        ...state,
        groups: action.answers,
      };
    case "REPLACE_IMAGE":
      return {
        ...state,
        picture: action.url,
      };
    default:
      throw state;
  }
}

export const ProductContext = ({ initialState, ...props }) => {
  const [productState, dispatch] = React.useReducer(reducer, initialState);
  const reduxDispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "INIT", product: initialState });
  }, [initialState]);

  const saveProduct = useCallback(() => {
    reduxDispatch(saveProductAction(productState._id, productState));
  }, [productState]);

  return (
    <Context.Provider value={{ productState, dispatch, saveProduct }}>
      {props.children}
    </Context.Provider>
  );
};
